import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class BillingErrorResponse {
    hasInvalidServiceStatus() {
        return this.error.hasErrorMessageIncluding('invalid service status');
    }
    isStaleBillingData() {
        return this.hasInvalidServiceStatus() || this.error.hasServerError([
            ServerError.MaxChargesExceeded,
            ServerError.RelationshipNotBillable
        ]);
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
